module.exports = __webpack_public_path__ + "static/cover-bae493ccc1468988f02b75cd4c4f8927.webp";